// The Relationship Explorer has no way back into the loop (one-view-per-group
// design, 22 Sep 2026): when a node is expanded, the node it was expanded
// from - and anything else already on the path back to the root - is not
// offered again as one of its children. The breadcrumb on the left is the
// way back; re-listing an ancestor just invites walking in a circle.
//
// children: the newly fetched child nodes, each with a `guid`.
// pathGuids: every ancestor's GUID from the root down to (and including) the
// node being expanded. Root has no ancestors, so it passes an empty list and
// nothing is filtered.
export function withoutWayBack(children, pathGuids) {
  if (!Array.isArray(children) || !children.length) return children || [];
  const ancestors = new Set((pathGuids || []).filter(Boolean));
  if (!ancestors.size) return children;
  return children.filter((child) => !ancestors.has(child.guid));
}
